module.exports = __webpack_public_path__ + "static/OP6-2ca341f8c62007b4d06797ef0b413d29.jpg";